import Typography from '@shared/constants/Typography';
import Colors from '@shared/theme/colors';
import {palette} from '@shared/theme/colorGroups/palette.colors';
import {StyleSheet} from 'react-native';

export const ConfirmLogoutModalStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      backgroundColor: palette.opacity.modalBackdrop,
    },
    modal: {
      backgroundColor: Colors.white,
      borderRadius: Typography.radius.radius12,
      padding: Typography.padding.padding24,
    },
    header: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.spaceBetween,
      paddingBottom: Typography.padding.padding16,
      gap: Typography.gap.gap110,
    },
    headerTitle: {
      fontSize: Typography.fontSize.fontSize24,
      fontWeight: Typography.fontWeight.bold,
      fontFamily: Typography.fontFamily.rethinkSans,
      textAlign: Typography.textAlign.leftAlign,
      color: theme.headerText,
      lineHeight: Typography.lineHeight.lineHeight36,
    },
    titleSubContainer: {
      gap: Typography.gap.gap10,
      justifyContent: Typography.contentAlign.flexStart,
      alignItems: Typography.contentAlign.flexStart,
    },
    titleContainer: {
      gap: Typography.gap.gap24,
      justifyContent: Typography.contentAlign.flexStart,
      alignItems: Typography.contentAlign.flexStart,
      paddingBottom: Typography.padding.padding24,
    },
    title: {
      fontSize: Typography.fontSize.fontSize16,
      fontWeight: Typography.fontWeight.bold,
      fontFamily: Typography.fontFamily.inter,
      textAlign: Typography.textAlign.centerAlign,
      color: theme.headerText,
    },
    message: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.regular,
      fontFamily: Typography.fontFamily.inter,
      textAlign: Typography.textAlign.centerAlign,
      color: theme.headerText,
    },
    buttonContainer: {
      flexDirection: 'row',
      alignItems: Typography.contentAlign.flexEnd,
      alignSelf: Typography.contentAlign.flexEnd,
    },
    customTextStyle: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      fontFamily: Typography.fontFamily.inter
    },
  });
